import { Produit } from 'src/app/parametrage/core/model/produit';

export class ProfessionnelFaciliteItem
{
    produit:String;
    montant:number;
    echeance:number;
    nombreEcheance:number;
    payeurFinal:String;
    tauxInteret:number;
    commissionOperationCredit:number;
    fraisDossier:number;
    commissionEngagement:number;
    objetFinancement:String;
}